module.exports = __webpack_public_path__ + "img/chevron-down--pink.3edcd8a1.svg";